import ToggleItem from './toggle_item';

export default class Freeze extends ToggleItem {
  constructor() {
    super('freeze');
  }
}
